import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './core/components/shell/shell.component';
import { AppResolver } from './core/services/app.resolver';
import { TitleResolver } from './core/services/title.resolver';

const routes: Routes = [
    {
        path: '',
        resolve: [AppResolver],
        component: ShellComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
                title: 'Crypto Research and Analysis | IXFI'
            },
            {
                path: 'news',
                loadChildren: () => import('./news/news.module').then(m => m.NewsModule),
                title: 'Cryptocurrency News & Market Updates | IXFI'
            },
            {
                path: '',
                loadChildren: () => import('./coin/coin.module').then(m => m.CoinModule),
                title: TitleResolver
            }
        ]
    },
    {
        path: 'server-management',
        loadComponent: () =>
            import('./standalone/components/maintenance/maintenance.component').then(c => c.MaintenanceComponent),
        title: 'Research | IXFI'
    },
    {
        path: 'page-not-found',
        loadComponent: () =>
            import('./standalone/components/page-not-found/page-not-found.component').then(
                c => c.PageNotFoundComponent
            ),
        title: 'Research | IXFI'
    },
    {
        path: '**',
        loadComponent: () =>
            import('./standalone/components/page-not-found/page-not-found.component').then(
                c => c.PageNotFoundComponent
            ),
        title: 'Research | IXFI'
    }
];

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 110],
    initialNavigation: 'enabledBlocking'
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
